import React, {useMemo, useState} from 'react';
import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {OptionButton} from "../../../../designSystem/components/OptionButton";
import {PaginationBar, TotalDisplay} from "../../../../components/PaginationBar";
import {StandardLayout} from '../../../../components/StandardLayout';
import {AuditLogTable} from "../AuditLogTable";
import {AuditLogJsonPopover} from "../AuditLogJsonPopover";

import {useExportAuditLogs} from "../../hooks/useExportAuditLogs";
import {useAuditLogs} from "../../hooks/useAuditLogs";
import {useJsonPopover} from "../../hooks/useJsonPopover";
import {AuditLogRange} from "../../api/auditLogs";
import {sortAuditLogs} from "../../model/sortAuditLogs";

const PAGE_SIZE = 30;

const RANGE_OPTIONS: Array<{label: string; value: AuditLogRange}> = [
  {label: '今天', value: 'today'},
  {label: '7天內', value: '7days'},
  {label: '1個月內', value: '1month'},
  {label: '1年內', value: '1year'},
  {label: '全部', value: 'all'},
];

export const AuditLogFeature = ({userToken}) => {
  const [selectedRange, setSelectedRange] = useState<AuditLogRange>('today');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const {loading, auditLogs} = useAuditLogs(userToken, selectedRange);
  const {jsonPopover, popoverPos, showJson, moveJson, hideJson} = useJsonPopover();

  const sortedAuditLogs = useMemo(() => {
    return sortAuditLogs(auditLogs);
  }, [auditLogs]);

  const numberOfPages = Math.ceil(sortedAuditLogs.length / PAGE_SIZE);
  const paginatedAuditLogs = useMemo(() => {
    const startRow = (currentPage - 1) * PAGE_SIZE;
    const endRow = currentPage * PAGE_SIZE;
    return sortedAuditLogs.slice(startRow, endRow);
  }, [sortedAuditLogs, currentPage]);

  const onSelectRange = (range: AuditLogRange) => {
    setSelectedRange(range);
    setCurrentPage(1);
  };

  const { exportData } = useExportAuditLogs({ data: sortedAuditLogs });

  if(loading) return <LoadingView />
  return (
    <StandardLayout
      headerTitle='系統編輯紀錄'
      headerActionLabel="匯出資料"
      headerActionIcon="fa-file-export"
      headerActionOnClick={exportData}
      body={
        <div className='relative flex flex-col gap-4'>
          <div className='flex flex-wrap gap-2'>
            {RANGE_OPTIONS.map((item) => (
              <OptionButton
                key={item.value}
                isSelected={selectedRange === item.value}
                onClick={() => onSelectRange(item.value)}
                label={item.label}
              />
            ))}
          </div>

          <TotalDisplay numberOfData={sortedAuditLogs.length} />

          {sortedAuditLogs.length > 0 ? (
            <React.Fragment>
              <AuditLogTable
                sortedAuditLogs={paginatedAuditLogs}
                showJson={showJson}
                moveJson={moveJson}
                hideJson={hideJson}
              />
              <PaginationBar
                currentPage={currentPage}
                numberOfPages={numberOfPages}
                onPageChange={setCurrentPage}
              />
            </React.Fragment>
          ) : null}

          <AuditLogJsonPopover
            jsonPopover={jsonPopover}
            popoverPos={popoverPos}
          />
        </div>
      }
    />
  );
};
